// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__39gtF","title":"ClientInsurance_title__3OVNe","itemText":"ClientInsurance_itemText__1H5Hr"};